var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/Original.736abb42.png","uri@3x": __webpack_public_path__ + "static/media/Original.2b70c4e2.png","uri@2x": __webpack_public_path__ + "static/media/Original.f078b476.png",
    width: 24,
    height: 24
});